import { render, staticRenderFns } from "./ProductMessage.vue?vue&type=template&id=03b07a81&scoped=true&"
import script from "./ProductMessage.vue?vue&type=script&lang=js&"
export * from "./ProductMessage.vue?vue&type=script&lang=js&"
import style0 from "./ProductMessage.vue?vue&type=style&index=0&id=03b07a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b07a81",
  null
  
)

export default component.exports